import { CurrencyOrDefaultPipe } from './currency-or-default.pipe';
import { UlaObjectValues } from './object-values.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';

export const Pipes = [
  CurrencyOrDefaultPipe,
  UlaObjectValues,
  SafeHtmlPipe
];
